import { render, staticRenderFns } from "./memberBlessing.vue?vue&type=template&id=08bf9201&scoped=true&"
import script from "./memberBlessing.vue?vue&type=script&lang=js&"
export * from "./memberBlessing.vue?vue&type=script&lang=js&"
import style0 from "./memberBlessing.vue?vue&type=style&index=0&id=08bf9201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf9201",
  null
  
)

export default component.exports